import { EDIT_THEME } from "./actionTypes";

export const editTheme = (theme) => ({
  type: EDIT_THEME,
  theme,
});
